import { Component, OnInit } from '@angular/core';

import { AuthService } from '@app/core/auth.service';
import { BeforeInstallPromptChoices, WindowService } from '@app/utils/window.service';

import { AnalyticsService } from './core/analytics.service';

@Component({
  selector: 'om-app',
  templateUrl: './app.component.html',
  providers: [],
})
// Component controller
export class MyOneApp implements OnInit {
  constructor(
    private windowService: WindowService,
    private analyticsService: AnalyticsService,
    private authService: AuthService,
  ) {}

  ngOnInit() {
    this.authService.init();

    this.windowService.appInstallChoiceStream.subscribe(choiceResult => {
      if (choiceResult.outcome === BeforeInstallPromptChoices.Dismissed) {
        this.analyticsService.appInstallBannerDismissed();
      } else {
        this.analyticsService.appInstallBannerAccepted();
      }
    });
  }
}
